import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FeaturedMortgageGuide() {
  return <section data-section-id="256182" id="지금-바로-진단받기" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col items-start space-y-6 order-2 lg:order-1">
            
          </div>

          {}

        </div>
      </div>
    </section>;
}